import type { MatchEvents, Player, PlayerStats } from 'modules/client/tournaments/domain/types';

const emptyStats = {
  goals: 0,
  assists: 0,
  redCards: 0,
  appearances: 0,
  yellowCards: 0,
};

function calculatePlayersStats(players: Player[], matchEvents: MatchEvents[]): Player[] {
  const stats = matchEvents.reduce(
    (stats, event) => {
      if (!event.userId || !event.type) {
        return stats;
      }

      const statsPlayer = stats[event.userId] ?? { ...emptyStats };

      const statsSecondPlayer = event.secondaryUserId ? (stats[event.secondaryUserId] ?? { ...emptyStats }) : { ...emptyStats };

      switch (event.type) {
        case 'goal':
        case 'corner':
        case 'penalty':
          if (event.secondaryUserId) {
            statsPlayer.assists += 1;
            statsSecondPlayer.goals += 1;
          } else {
            statsPlayer.goals += 1;
          }
          break;
        case 'redcard': {
          statsPlayer.redCards += 1;
          break;
        }
        case 'yellowcard': {
          statsPlayer.yellowCards += 1;
          break;
        }
      }

      stats[event.userId] = statsPlayer;
      event.secondaryUserId && (stats[event.secondaryUserId] = statsSecondPlayer);
      return stats;
    },
    {} as Record<number, PlayerStats>,
  );

  return players.map((player) => {
    return { ...player, ...stats[player.id] };
  });
}

export default calculatePlayersStats;
